import { addFavoriteCompleted } from "../actions/v2/addFavoriteActions";
import { orchestrator } from "satcheljs";
import { logUsage } from "owa-analytics";
import { getIsBitSet, type ListViewBitFlagsMasks, setBitAndUpdateAccountScopeUserSettingsAndService } from "owa-bit-flags/lib/utils/listViewBitFlagsUtil";
import { getGlobalSettingsAccountMailboxInfo } from "owa-account-source-list-store";
import onFavoriteParsingComplete from "../actions/onFavoriteParsingComplete";

export default <(actionMessage: ReturnType<typeof addFavoriteCompleted>) => void | Promise<void>>(
/* eslint-disable-next-line owa-custom-rules/forbid-orchestrator-in-same-package -- (https://aka.ms/OWALintWiki)
 * Baseline. DO NOT COPY AND PASTE!
 *	> Do not register an orchestrator with an action that is defined in the same package */
orchestrator(addFavoriteCompleted, actionMessage => {
    const shouldHideFavoritesList = getIsBitSet(16384, getGlobalSettingsAccountMailboxInfo());
    if (shouldHideFavoritesList) {
        logUsage("FP_ShowFavorite_FavoriteAdded", actionMessage.favoriteData.mailboxInfo);
        setBitAndUpdateAccountScopeUserSettingsAndService(false, 16384, getGlobalSettingsAccountMailboxInfo());
    }
    
    onFavoriteParsingComplete([actionMessage.favoriteData.favoriteId]);
}));
